var AppLiveLanding = (function() {
  var appDevice = document.getElementById("app-device"),
    appDeviceSkin = document.getElementById("app-device-skin"),
    appVideo = document.getElementById("app-video"),
    logsContnet = document.getElementById("content");
  function init() {
    imgLoad();
  }

  function imgLoad() {
    /**
     * Start the video only after the mobile device skin is loaded.
     */
    appDeviceSkin.onload = function() {
      handleVideo();
    };
  }

  function handleVideo() {
    var srcPath = appDevice.getAttribute("data-path"),
      logsContainer = document.getElementById("logs-container");

    /**
     * Hide on Mobile
     */
    window.onresize = function() {
      if (window.innerWidth > 640) {
        logsContainer.style.display = "block";
      } else {
        logsContainer.style.display = "none";
      }
    };

    if (window.innerWidth > 640) {
      logsContainer.style.display = "block";
    }

    appVideo.style.display = "block";

    /**
     * Creating source Element to append inside the video tag
     */
    var source = document.createElement("source");
    source.src = srcPath + "/videos/app-live-video.mp4";
    source.type = "video/mp4";
    appVideo.appendChild(source);

    appVideo.ontimeupdate = function() {
      var nextTime = timings[next];
      var delta = this.currentTime - nextTime;
      if (delta > 0 && delta < 1) {
        var messages = logs[next];
        var $messages = logsContnet.querySelectorAll(".message");
        next += 1;

        if (next === timings.length) {
          next = 0;
        }

        if (!Array.isArray(messages)) {
          messages = [messages];
        }

        var count = 0,
          animate = function() {
            var timer = setInterval(function() {
              logsContnet
                .querySelectorAll(".message")[0]
                .classList.add("animatetop");
              setTimeout(function() {
                logsContnet.querySelectorAll(".message")[0].remove();
              }, 400);

              appendMessage(messages[count]);
              count += 1;
              if (count < messages.length) {
                animate();
              } else {
                clearInterval(timer); // finish the animation after 300 ms
                return;
              }
            }, 300);
          };

        if ($messages.length > 3) {
          animate();
        } else {
          messages.forEach(appendMessage);
        }
      }
    };
    appVideo.loadedmetadata = function() {
      this.controls = /Mobi/.test(navigator.userAgent);
    };
  }

  function appendMessage(message) {
    var div = document.createElement("div");
    div.textContent = formatMessage(message);
    div.setAttribute("class", "message");
    logsContnet.appendChild(div);
  }

  function formatMessage(message) {
    return "> " + formatDate() + prefix + message;
  }

  function formatDate() {
    var date = new Date().toISOString(),
      tIndex = date.indexOf("T"),
      formattedDate = date.substring(date.indexOf("-") + 1, tIndex),
      formattedTime = date.substring(tIndex + 1, date.indexOf("Z"));
    return formattedDate + " " + formattedTime;
  }

  var timings = [0.24, 4.21, 6.02, 8.26, 11.23, 14.11, 16.02],
    logs = [
      "Tap: Received text : Launched app from home screen",
      "Tap: Lat/Long: Search for an address",
      "Tap: Received text: Keystroke input",
      "Tap: Received text: Search (bleecker st)",
      "Tap: Received text: Navigation start",
      "Tap: Received text: Multitouch Input",
      "SwipeUp: Received text: Minimize app"
    ],
    prefix = " 02-26 08:00:36.850/com.app.waze D /",
    next = 0;
  return { init: init };
})();

AppLiveLanding.init();
